export default __webpack_public_path__ + "static/media/steps__slider-main-item-icon-2.6072887e.svg";